export const enum StatusDisplayType {
    MessageDialog = 0,
    Label = 1,
}
